import { Page } from '@/components/page';
import { CodeEditorWidget } from '@/features/editor/components/code-editor-widget';
import { DiffEditorWidget } from '@/features/editor/components/diff-editor-widget';
import { useScreenId } from '@/hooks/use-screen-id';
import { useTabId } from '@/hooks/use-tab-id';

export function CodeEditor() {
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!tabId || !screenId) {
    return null;
  }

  return (
    <Page title="Agent Editor">
      <div className="grid gap-4">
        <CodeEditorWidget id={`${idPrefix}/code-editor`} />
        <DiffEditorWidget id={`${idPrefix}/diff-editor`} />
      </div>
    </Page>
  );
}
